<template>
  <div class="bg-white p-1 rounded-xl shadow-md">
    <!-- Chart -->
    <div class="row">
      <Bar :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
)

export default {
  name: 'AnnualRevenueChart',
  components: { Bar },

  data() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              boxWidth: 10,
              padding: 20,
              color: '#697a8d',
              font: { size: 14 }
            }
          },
          tooltip: {
            callbacks: {
              label(context) {
                const value = context.raw || 0
                return `${context.dataset.label}: ${(
                  value / 1000000
                ).toLocaleString()} VND`
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: '#697a8d',
              font: {
                size: 14,
                weight: '500'
              }
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              drawBorder: false,
              borderDash: [8, 6],
              color: "lightgray"
            },
            title: {
              display: true,
              text: 'Unit: 1 Mil VND',
              align: 'end',
              color: '#697a8d',
              font: {
                size: 12,
                weight: '500',
                style: 'italic',
              }
            },
            ticks: {
              color: '#697a8d',
              callback: value => (value / 1000000).toLocaleString(),
              maxTicksLimit: 5,
              font: { 
                size: 14,
                weight: '500'
              }
            }
          }
        }
      }
    }
  },

  computed: {
    chartData() {
      return this.$store.getters['dashboard/chartData']
    }
  },

  created() {
    this.$store.dispatch('dashboard/fetchRevenueProfitChartData')
  }
}
</script>

<style scoped>

</style>
